import { createAction, union } from '@ngrx/store';

export const updateUnderMaintenance = createAction(
  'MeintenanceActions updateUnderMaintenance',
  (payload: boolean) => ({ payload }),
);

export const storeMaintenanceMessage = createAction(
  'MeintenanceActions storeMaintenanceMessage',
  (payload: string) => ({ payload }),
);

export const resetState = createAction('MeintenanceActions resetState');

const all = union({
  updateUnderMaintenance,
  storeMaintenanceMessage,
  resetState,
});

export type MaintenanceActionsUnion = typeof all;
